<template>
    <el-container>
        <el-aside width="110px">
            <el-menu class="main-menu" unique-opened router collapse :default-active="onRoutes">
                <img class="logo" src="~../assets/logo.png" alt="">
                <el-menu-item index="/index">
                    <img class="avatar" v-if="user_profile.avatar && user_profile.avatar.url" src="user_profile.avatar.url" alt="">
                    <img class="avatar" v-else src="~../assets/default_avatar.svg" alt="">
                    <span slot="title">首页看版</span>
                </el-menu-item>
                <el-menu-item index="/homework">
                    <img class="img-icon" src="~../assets/homework.svg" alt="">
                    <span slot="title">布置作业</span>
                </el-menu-item>
                <div class="secondary-menu">
                  <div class="exit" @click="exit">
                    <img class="img-icon" src="~../assets/exit.svg" alt="">
                  </div>
                </div>
            </el-menu>

        </el-aside>
        <el-main style="padding:0">
            <router-view></router-view>
        </el-main>
    </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { removeCookie } from 'tiny-cookie'

export default {
  data () {
    return {}
  },

  created () {
    this.$store.dispatch('user_profile')
  },
  computed: {
    ...mapGetters(['user_profile']),
    onRoutes () {
      let index = this.$route.path.indexOf('/', 2)
      return this.$route.path.substring(0, index)
    }
  },
  methods: {
    exit () {
      removeCookie('access_token')
      this.$router.replace('/')
    }
  }
}
</script>
<style lang="scss">
.el-container,
.el-aside,
.el-menu {
  height: 100%;
  min-height: 600px;
}

.el-menu.main-menu {
  &.el-menu--collapse {
    width: 100px;
    .el-tooltip{
        padding: 0!important;
    }
    .logo {
      width: 100px;
      height: 100px;
      object-fit: cover;
    }
    .avatar {
      width: 60px;
      height: 60px;
      object-fit: cover;
      border-radius: 50%;
    }
    .img-icon {
      width: 40px;
      height: 40px;
      object-fit: cover;
    }
    .el-menu-item,
    .el-submenu__title {
      text-align: center;
      height: 80px;
      line-height: 80px;
    }
    .el-menu-item i {
      font-size: 38px;
      width: 38px;
    }
  }
  background-color: rgb(51, 0, 102);
  .el-menu-item i {
    color: #fff;
  }
  .el-menu-item {
    &:focus,
    &:hover {
      background-color: #440188;
    }
    &.is-active {
      color: #fff;
      background-color: rgb(51, 0, 102);
      position: relative;
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        right: -1px;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-right-color: #fff;
      }
    }
  }

  .secondary-menu{
    position: absolute;
    bottom: 0;
    width: 100px;
    .exit{
      width:100px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      cursor: pointer;
      img{
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
}
</style>
